import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Pagenation from 'widget/Pagenation'

import useGetExamList from 'entity/exam/useGetExamList'

import TStyle from 'shared/style/tableStyle'
import TableLoading from 'shared/ui/TableLoading'
import QualificationExamModal from 'shared/ui/QualificationExamModal'
import DefaultButton from 'shared/ui/DefaultButton'

const TryoutExamList = () => {
	const navigate = useNavigate()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [selectedExam, setSelectedExam] = useState(null)

	const [examList, isLoading, fetchRequest] = useGetExamList()
	const sizeList = [
		'short',
		'expand',
		'expand',
		'expand',
		'expand',
		'expand',
		'expand',
		'expand',
		'expand',
		'short',
	]
	const tableHeadList = [
		'번호',
		'시험명',
		'브랜드명',
		'1단계',
		'1단계 가격',
		'2단계',
		'2단계 가격',
		'3단계',
		'3단계 가격',
		'',
	]

	return (
		<Style.Wrapper>
			<MainHeader>모의고사 관리</MainHeader>

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{examList?.data?.exam_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => navigate(`/exam/${elem?.idx}/version`)}
							>
								<TStyle.Data $size={sizeList[0]}>
									{elem?.idx || '시스템'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>
									{elem?.brand_name}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>{elem?.level_2}</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{elem?.price_level_2?.toLocaleString() ?? '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[5]}>{elem?.level_4}</TStyle.Data>
								<TStyle.Data $size={sizeList[6]}>
									{elem?.price_level_4?.toLocaleString() ?? '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[7]}>{elem?.level_6}</TStyle.Data>
								<TStyle.Data $size={sizeList[8]}>
									{elem?.price_level_6?.toLocaleString() ?? '-'}
								</TStyle.Data>

								<TStyle.Data $size={sizeList[9]}>
									<DefaultButton
										key={index}
										fitWidth
										small
										clickEvent={(e) => {
											e.stopPropagation()
											setSelectedExam(elem)
											setIsOpenModal(true)
										}}
									>
										수정
									</DefaultButton>
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={examList?.data?.max_page} />
			{isOpenModal && (
				<QualificationExamModal
					closeEvent={() => setIsOpenModal(false)}
					data={selectedExam}
					fetchRequest={fetchRequest}
				/>
			)}
		</Style.Wrapper>
	)
}

export default TryoutExamList
